"use strict";

export class AudioGroup {
    constructor(config) {
        this.audioTracks = config.audioTracks;

        this.volume = config.volume === undefined ? 1 : config.volume;
        this.audioTracks.forEach(track => track.setVolume(this.volume));

        this.muted = config.muted === undefined ? false : config.muted;
        this.audioTracks.forEach(track => track.setMute(this.muted));
    }

    setVolume(volume) {
        if (volume === undefined) return;

        this.volume = volume;
        this.audioTracks.forEach(track => track.setVolume(this.volume));
    }

    setMute(mute) {
        if (mute === undefined) {
            mute = !this.muted;
        }

        this.muted = mute;
        this.audioTracks.forEach((track) => track.setMute(this.muted));
    }
}